import { FC } from "react"

const TriangleExclamationIcon: FC<any> = ({ ...props }) => {
  return (
    <svg width="30" height="28" viewBox="0 0 30 28" fill="none" {...props}>
      <path
        d="M 13.1 4.2 V 9.7 C 13.1 10.3 13.1 10.9 13 11.4 C 13 12 12.9 12.6 12.8 13.2 H 11.2 C 11.1 12.6 11 12 10.9 11.4 C 10.9 10.9 10.9 10.3 10.9 9.7 V 4.2 H 13.1 Z M 10.5 16.8 C 10.5 16.6 10.5 16.4 10.6 16.3 C 10.7 16.1 10.8 15.9 10.9 15.8 C 11 15.7 11.2 15.6 11.4 15.5 C 11.6 15.4 11.8 15.4 12 15.4 C 12.2 15.4 12.4 15.4 12.5 15.5 C 12.7 15.6 12.9 15.7 13 15.8 C 13.1 15.9 13.2 16.1 13.3 16.3 C 13.4 16.4 13.4 16.6 13.4 16.8 C 13.4 17 13.4 17.2 13.3 17.4 C 13.2 17.6 13.1 17.7 13 17.9 C 12.9 18 12.7 18.1 12.5 18.2 C 12.4 18.2 12.2 18.3 12 18.3 C 11.8 18.3 11.6 18.2 11.4 18.2 C 11.2 18.1 11 18 10.9 17.9 C 10.8 17.7 10.7 17.6 10.6 17.4 C 10.5 17.2 10.5 17 10.5 16.8 Z"
        fill="#3d4f83"
      />
      <path
        d="M 10.7 2 C 11.3 1.1 12.7 1.1 13.3 2 L 22.7 17.2 C 23.3 18.2 22.6 19.5 21.4 19.5 H 2.6 C 1.4 19.5 0.7 18.2 1.3 17.2 L 10.7 2 Z"
        stroke="#3d4f83"
      />
    </svg>
  )
}

export default TriangleExclamationIcon
